import {atomFamily} from "recoil";

/**
 * 참조자 수 카운트
 * @type {RecoilState<number>}
 */
export const referrerCountAtomFamily = atomFamily({
    key: "referrerCountAtomFamily",
    default: (key) => ({
        count:0,
        keyName: key
    }),
})